// import React from 'react';
import React, { useEffect, useState } from 'react';

import { useLocation, useParams } from 'react-router-dom';
import blueyumwayseasmith from "../assets/img/blueyumwayseasmith.png";
import aboutbannerx10 from "../assets/img/aboutbannerX10.png";
import { Link } from 'react-router-dom';
import year_title_bg from '../assets/img/update_2/bg/year_title_bg.svg'
import year_title_bg51 from '../assets/img/update_2/bg/year_title_bg51.svg'
import bgbanner2 from '../assets/img/update_2/bg/bannerbg2.png'
import mapx1 from "../assets/img/mapx1.jpg";
import mapx444 from "../assets/img/mapx444.jpg";
import 'slick-carousel/slick/slick.css';
import 'slick-carousel/slick/slick-theme.css';
import about_6_1 from "../assets/img/update_2/normal/about_6_1.png";
import dishround from "../assets/img/update_2/normal/dishround.png";
import roundpotato from "../assets/img/update_2/normal/roundedpotato.png";
import contractfarm01 from "../assets/img/update_2/icon/contractfarm01.jpg";
import farmicon1 from "../assets/img/update_2/icon/farmicon1.svg";
import farm111 from "../assets/img/update_2/icon/farm111.jpg";
import farming222 from "../assets/img/update_2/icon/farming222.jpg";
import consistent01 from "../assets/img/update_2/icon/consistent01.jpg";
import consistenet111 from "../assets/img/update_2/icon/consistenet111.jpg";
import consistent222 from "../assets/img/update_2/icon/consistent222.jpg";
import quick01 from "../assets/img/update_2/icon/quick01.jpg";
import quick111 from "../assets/img/update_2/icon/quick111.jpg";
import quick222 from "../assets/img/update_2/icon/quick222.jpg";
import longshelf01 from "../assets/img/update_2/icon/longshelf01.jpg";
import longshelf111 from "../assets/img/update_2/icon/longshlef111.jpg";
import longshelf222 from "../assets/img/update_2/icon/longshelf222.jpg";
import tiger01 from "../assets/img/update_2/icon/tiger01.jpg";
import proudlymade111 from "../assets/img/update_2/icon/proudlymade111.jpg";
import tiger222 from "../assets/img/update_2/icon/tiger222.jpg";
import flexibility01 from "../assets/img/update_2/icon/flexibility01.jpg";
import flexibility111 from "../assets/img/update_2/icon/fexibility111.jpg";
import flexibility222 from "../assets/img/update_2/icon/flexibility222.jpg";
import testicardimg from "../assets/img/update_2/normal/testi-card_img.png";
import qualitydrivenupdated1 from "../assets/img/update_2/normal/qualitydrivenupdated1.jpg";
import mission1 from "../assets/img/update_2/normal/mission1.png";
import vision1 from "../assets/img/update_2/normal/vision1.png";
import customerfocuedupdated1 from "../assets/img/update_2/normal/customerfocusedupdated1.jpg";
import td11 from "../assets/img/update_2/normal/td11.jpg";
import backwardintegration1 from "../assets/img/update_2/normal/backwardintegration1.png";
import backint from "../assets/img/update_2/normal/backint.png";
import bgfriesupdated from "../assets/img/update_2/normal/bgfriesupdated.jpg";

import shrimpovingimgx1 from "../assets/img/update_2/normal/shrimpmovingimgx1.png";
import potatosmovingimgx1 from "../assets/img/update_2/normal/potatomovingimgx1.png";

import Footer from './footer';


const PrivacyPolicy = () => {
    const location = useLocation();

    useEffect(() => {
        const { hash } = location;
        if (hash) {
            const id = hash.substring(1);
            const element = document.getElementById(id);
            if (element) {
                element.scrollIntoView({ behavior: 'smooth', block: 'start' });
            }
        }
    }, [location]);




    return (


        <div>
       
            <div classNameName="d-none d-md-block">
                <div id="slider" classNameName="ls-wp-container fitvidsignore hero-6 th-hero-carousel"
                    style={{ margin: '0 auto' }}>


                    <div classNameName="ls-slide" data-ls="duration:5000; kenburnsscale:1.2;">
                        <div className="infrastructure-name">
                            <div style={{ marginTop: "25px" }}>
                                <ul style={{ listStyleType: 'none', padding: 20 }}>
                                    <li><h1 style={{ color: 'white', margin: 0, padding: 0 ,fontFamily: 'helvetica', color: 'white'}}>PRIVACY POLICY</h1></li>
                                    <li>
                                        <Link to="/home" style={{ color: 'white', padding: 4 }}><span className="homeclass" style={{ fontFamily: 'helvetica' }}>Home</span> &nbsp;</Link>
                                        <span style={{ color: 'white' }}>&gt; &nbsp;<span className="redname" style={{ fontFamily: 'helvetica', color: '#F0B323' }}>Privacy Policy</span></span>
                                    </li>
                                </ul>

                            </div>

                        </div>
                        <img
                            width="2000"
                            height="435"
                            src={aboutbannerx10}
                            className="ls-l ls-img-layer factory"
                            alt="image"
                            decoding="async"
                            style={{
                                fontSize: '36px',

                                color: '#000',
                                stroke: '#000',
                                strokeWidth: '0px',
                                textAlign: 'right',
                                fontStyle: 'normal',
                                textDecoration: 'none',
                                textTransform: 'none',
                                fontWeight: '400',
                                letterSpacing: '0px',
                                backgroundPosition: '0% 0%',
                                backgroundRepeat: 'no-repeat',
                                backgroundClip: 'border-box',
                                overflow: 'visible',
                                left: '0px',
                                top: '107px',
                                WebkitBackgroundClip: 'border-box'
                            }}
                            data-ls="offsetxin:500; durationin:600; delayin:100; easingin:easeOutBack; rotatein:80; bgcolorin:transparent; colorin:transparent;"
                        />

                    </div>



                </div>
            </div>

            <br />

            {/* Privacy Policy Content */}
            <div className="container">
                <p>
                    At <strong>Icedream Global</strong> (a brand by <strong>Gobind Ram Kahan Chand</strong>), we respect your
                    privacy and are committed to protecting your personal information. This Privacy Policy explains how we
                    collect, use, and safeguard the details you share with us through our distributor enquiry forms and campaigns.
                </p>

                <h6>1. Information We Collect</h6>
                <p>When you fill out our enquiry forms, we may collect:</p>
                <ul>
                    <li>Name</li>
                    <li>Email Address</li>
                    <li>Phone Number</li>
                    <li>Company/Business Name</li>
                    <li>City/Location</li>
                    <li>Any other details you voluntarily provide</li>
                </ul>

                <h6>2. How We Use Your Information</h6>
                <p>We use your information only for the following purposes:</p>
                <ul>
                    <li>To respond to your enquiry about distributorship opportunities</li>
                    <li>To share product catalogues, pricing, and business details</li>
                    <li>To follow up with you via email, phone, or WhatsApp</li>
                    <li>To improve our products and services</li>
                </ul>

                <h6>3. Data Sharing</h6>
                <p>We do not sell or rent your personal information to third parties. We may share data only in these cases:</p>
                <ul>
                    <li>With our internal sales and support teams to respond to your request</li>
                    <li>When required by law or government authorities</li>
                </ul>

                <h6>4. Data Security</h6>
                <p>We take reasonable measures to protect your data from unauthorized access, disclosure, alteration, or destruction.</p>

                <h6>5. Your Rights</h6>
                <p>You may request to update, correct, or delete your personal information by contacting us at the email below.</p>

                <h6>6. Contact Us</h6>
                <p>
                    If you have questions about this Privacy Policy or how your data is used, please contact us at:<br />
                    <strong>Email:</strong> support@icedreamglobal.com
                </p>
            </div>
            <br />
            <br />

        
          
            <Footer />

        </div>
    );
};

export default PrivacyPolicy;
